import type { ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

type BackendUnavailableStateProps = {
  action?: ReactNode;
  eyebrow?: string;
  title?: string;
};

export function BackendUnavailableState({
  action,
  eyebrow = "ThreadOps",
  title = "Backend unavailable",
}: BackendUnavailableStateProps) {
  return (
    <section
      aria-labelledby="backend-unavailable-title"
      className="w-full rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] p-5 sm:p-6"
    >
      <div className="flex items-start gap-3">
        <div className="inline-flex size-10 shrink-0 items-center justify-center rounded-md bg-[color-mix(in_srgb,var(--color-warning)_14%,var(--color-surface))] text-[var(--color-warning)]">
          <AlertTriangle aria-hidden="true" className="size-5" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-[var(--color-brand)]">{eyebrow}</p>
          <h1 id="backend-unavailable-title" className="mt-1 text-2xl font-semibold">
            {title}
          </h1>
          <p className="mt-2 text-sm leading-6 text-[var(--color-foreground-muted)]">
            ThreadOps is running, but the data service cannot be reached right now.
            Try again shortly. If it keeps happening, ask an administrator to check
            the development backend status.
          </p>
          {action ? <div className="mt-5 flex flex-wrap gap-2">{action}</div> : null}
        </div>
      </div>
    </section>
  );
}
